import { render, staticRenderFns } from "./DemandsDetails.vue?vue&type=template&id=10c0a565&scoped=true"
import script from "./DemandsDetails.vue?vue&type=script&lang=js"
export * from "./DemandsDetails.vue?vue&type=script&lang=js"
import style0 from "./DemandsDetails.vue?vue&type=style&index=0&id=10c0a565&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c0a565",
  null
  
)

export default component.exports